export default class OrderFormType {
    static TTCheckSocket = 3;
    static TFCheckSocket = 4;
    static TTDefinitiveSocket = 5;
    static TFDefinitiveSocket = 6;
    static TTONESocket = 7;
    static TFONESocket = 8;
}